import { render } from "./HeaderComponent.vue?vue&type=template&id=65c7c3b9&scoped=true"
const script = {}

import "./HeaderComponent.vue?vue&type=style&index=0&id=65c7c3b9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c7c3b9"]])

export default __exports__